import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

/**
 * Emits `reachedBottom` when the user scrolls within `threshold` pixels of
 * the bottom of the host element. Apply directly to any element with
 * `overflow-y: auto` / `overflow-y: scroll`.
 *
 * Usage:
 *   <ul class="suggestions" tsInfiniteScroll (reachedBottom)="loadMore()">
 */
@Directive({
  selector: '[tsInfiniteScroll]',
  standalone: true,
})
export class InfiniteScrollDirective {
  /** Distance (in px) from the bottom at which the emission fires. */
  @Input() threshold = 50;

  @Output() reachedBottom = new EventEmitter<void>();

  constructor(private readonly host: ElementRef<HTMLElement>) {}

  @HostListener('scroll')
  onScroll(): void {
    const { scrollTop, clientHeight, scrollHeight } = this.host.nativeElement;
    if (scrollTop + clientHeight >= scrollHeight - this.threshold) {
      this.reachedBottom.emit();
    }
  }
}
